import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendStaffAppMetaData } from "../../eventTriggers";

export function Insurances() {
  const { insurances } = useSelector((state) => state);
  const tabDefaultMetaData = useSelector((state) =>
    state.config.tab_default_meta_data.find((tab) => tab.detail == "insurances")
  );
  const dispatch = useDispatch();

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "insurance",
        resource,
      },
    });
    sendStaffAppMetaData(tabDefaultMetaData.modal);
  }

  return (
    <div>
      {insurances.map((insurance) => (
        <div
          key={insurance.id}
          onClick={() => handleClick(insurance)}
          className="p-4 border-bottom clickable"
        >
          <b>{insurance.name}</b>
          <div>{insurance.policy_number}</div>
          <div>{insurance.phone_number}</div>
        </div>
      ))}
    </div>
  );
}
